import axios from "axios";
import React from "react";
import './Spinner.scss';
import Loading from '../../../assest/images/spinner.gif'

export default class Spinner extends React.Component<{}, { pendingRequest: number }> {

    /**
     *
     */
    constructor(props: any) {
        super(props);

        this.state = { pendingRequest: 0 };
    }
    componentDidMount() {

        axios.interceptors.request.use(async (config) => {
            try {
                if (config.url !== "version.json")
                    this.setState({ pendingRequest: this.state.pendingRequest + 1 });
            }
            catch (e) {
                alert('Error request' + e);
            }

            return config;
        }, () => {
            if (this.state.pendingRequest !== 0)
                this.setState({ pendingRequest: this.state.pendingRequest - 1 });
        });

        axios.interceptors.response.use(async (config) => {
            try {
                if (config.config.url !== "version.json")
                    this.setState({ pendingRequest: this.state.pendingRequest - 1 });
            }
            catch (e) {
                alert('Error response' + e);
            }

            return config;
        }, () => {
            if (this.state.pendingRequest !== 0)
                this.setState({ pendingRequest: this.state.pendingRequest - 1 });
        });
    }
    render(): React.ReactNode {
        return (<>{this.state.pendingRequest > 0 ? (<>
            <div className="blur"></div>
            <div className="spinner-area">
                <span className="spinner">در حال بارگزاری...</span>
                <img src={Loading} alt="spinner" />
            </div>
        </>):''}</>)
    }
}